import { LocalStorageKeys } from '../utils/network';

const clearLocalStorage = () => {
  localStorage.removeItem(LocalStorageKeys.AuthToken);
  localStorage.removeItem(LocalStorageKeys.AccessToken);
  localStorage.removeItem(LocalStorageKeys.RefreshToken);
  localStorage.removeItem(LocalStorageKeys.UserId);
  localStorage.removeItem(LocalStorageKeys.DeviceId);
  localStorage.removeItem(LocalStorageKeys.BrowserId);
  localStorage.removeItem('categories');
  localStorage.removeItem('tag_types');
  localStorage.removeItem('defaultTags');
  localStorage.removeItem('sources');
  localStorage.removeItem('users');
  localStorage.removeItem('scopes');
  localStorage.removeItem('locations');
};

export default clearLocalStorage;
